var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-editor',{attrs:{"placeholder":_vm.placeholder},on:{"text-change":function($event){return _vm.textChange()}},model:{value:(_vm.tmp_value),callback:function ($$v) {_vm.tmp_value=$$v},expression:"tmp_value"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e26a142","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/component/editor-input.vue
// module id = null
// module chunks = 